import { render, staticRenderFns } from "./claim-profile-card.vue?vue&type=template&id=421b35e1&scoped=true"
import script from "./claim-profile-card.vue?vue&type=script&lang=js"
export * from "./claim-profile-card.vue?vue&type=script&lang=js"
import style0 from "./claim-profile-card.vue?vue&type=style&index=0&id=421b35e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b35e1",
  null
  
)

export default component.exports